export default __webpack_public_path__ + "static/rs-empresarial_01-1d8d588b77c201e4bcaf35f1f90e0279.png";